import { errHandler } from "utils/common";
import api from "utils/api";

export default class Rujukan {
  getAll = (
    opt = {
      page: 1,
      limit: 10,
      searchBy: "",
      searchValue: "",
    }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get("/api/regmal-references", { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          errHandler(err);
        });
    });
  };

  getOne = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/regmal-reference/${id}`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/regmal-reference?device=Online", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/regmal-reference/${id}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
